module.exports = __webpack_public_path__ + "static/media/mplayer_1_12.3caca3dc.ico";